<template>
  <v-row class="align-end flex-wrap-reverse mt-5">
    <v-col cols="12" md="7" sm="12">
      <b-form hide-action-buttons :readonly="can('orders.update')">
        <v-row>
          <v-col cols="12" md="12" sm="12">
            <b-input
              v-model="order.name"
              :disabled="disabled"
              hide-details
              label="Назва наказу"
              placeholder="Введіть текст"
              readonly>
            </b-input>
          </v-col>
          <v-col cols="12" md="6" sm="12">
            <b-input
              v-model="order.number"
              :disabled="disabled"
              hide-details
              label="Номер наказу"
              placeholder="Введіть номер">
            </b-input>
          </v-col>
          <v-col cols="12" md="6" sm="12">
            <b-input-date
              v-model="order.date"
              :disabled="disabled"
              hide-details
              label="Дата наказу"
              time-picker></b-input-date>
          </v-col>
          <v-col cols="12" md="12" sm="12">
            <b-server-autocomplete
              v-model="order.issuedUserId"
              :defaultItem="order.issuedUser"
              :item-title="
                u =>
                  `${u.surname ? getPersonName(u) : u?.name} ${
                    !u.isActive && u?.id ? '(Звільнений)' : ''
                  }`
              "
              :search-min-length="3"
              :url="urlAllUsers()"
              has-empty
              hide-details
              item-value="id"
              label="Підготовив"
              placeholder="Введіть мін. 3 символи">
            </b-server-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6" sm="12">
            <b-select
              v-model="order.typeId"
              :items="$directory.get('orderTypes', order.type)"
              :loading="$loading.isLoading('orderTypes')"
              hide-details
              item-title="name"
              item-value="id"
              label="Тип"
              placeholder="Оберіть зі списку"
              @focus="$directory.fill('orderTypes')">
            </b-select>
          </v-col>
          <v-col cols="12" md="6" sm="12">
            <b-select
              v-model="order.directionId"
              :items="$directory.get('orderDirections', order.direction)"
              :loading="$loading.isLoading('orderDirections')"
              hide-details
              item-title="name"
              item-value="id"
              label="Напрямок"
              placeholder="Оберіть зі списку"
              @focus="$directory.fill('orderDirections')">
            </b-select>
          </v-col>
          <v-col cols="12" md="12" sm="12">
            <b-select
              v-model="order.departmentId"
              :items="$directory.get('departmentList', order.department)"
              :loading="$loading.isLoading('departmentList')"
              hide-details
              item-title="name"
              item-value="id"
              label="Департамент"
              placeholder="Оберіть зі списку"
              @focus="$directory.fill('departmentList')">
            </b-select>
          </v-col>
          <v-col cols="12" md="12" sm="12">
            <b-textarea
              v-model="order.description"
              :disabled="disabled"
              :rows="3"
              hide-details
              label="Опис наказу"
              placeholder="Введіть текст">
            </b-textarea>
          </v-col>
          <v-col cols="12" md="12" sm="12">
            <span class="label">Примітки</span>
            <Notes :disabled="!order.isActive" />
          </v-col>
        </v-row>
      </b-form>
    </v-col>
    <v-col cols="12" md="5" sm="12">
      <div>
        <v-card variant="outlined" class="mb-3" style="border-color: #49a2f4">
          <v-card-text>
            <div class="mb-3">
              <b>ВкладенняЖ</b>
            </div>
            <FilesUploader
              v-model="order.document"
              :accept="['.pdf']"
              :disabled="disabled"
              :name-folder="order.number"
              class="mb-3"
              file-list
              label="Файли наказу"
              main-folder="Приказы"
              noCard />
            <FilesUploader
              v-model="order.extraDocuments"
              :disabled="disabled"
              :name-folder="order.number"
              file-list
              label="Додаткові файли наказу"
              main-folder="Приказы"
              noCard
              @change="orderUpdateExtraDocument" />
          </v-card-text>
        </v-card>
        <div class="d-flex mb-3">
          <div v-if="acknowledgmentAccess">
            <v-btn
              v-if="isAcknowledgmentAgreed"
              size="small"
              style="cursor: default; pointer-events: none">
              Ознайомлений
            </v-btn>
            <v-btn
              v-else
              label="Ознайомитись"
              size="small"
              :loading="$loading.isLoading('acknowledgmentAgree')"
              @click="acknowledgmentAgree">
              Ознайомитись
            </v-btn>
          </div>
        </div>
        <div class="info">
          <div>
            <span>
              До ознайомлення:
              {{ acknowledgmentList.length }} користувачів
            </span>
            <span>
              Прочитано:
              {{ acknowledgmentList.filter(u => u.isAccept).length }}
              користувачів
            </span>
          </div>
          <div>
            <span>
              Дата створення:
              {{ new CustomDate(order.created_at).toString({ time: true }) }}
            </span>
            <span>
              Дата оновлення:
              {{ new CustomDate(order.updated_at).toString({ time: true }) }}
            </span>
            <span>Автор: {{ getPersonName(order.author) }}</span>
          </div>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { navigateToItem } from '@/utils/helpers.js'
import FilesUploader from '@/components/filesUploader/FilesUploader.vue'
import Notes from '@/components/notes/Notes.vue'
import { getPersonName, CustomDate } from 'best-modules/utils'
import {
  BServerAutocomplete,
  BTextarea,
  BForm,
  BInputDate,
} from 'best-modules/components'
import { urlAllUsers } from '@/utils/urls.js'
import { useOrder } from '../order'
import { useAcknowledgment } from '@/components/acknowledgment'
import { useCan } from '@/composables/useCan'

export default {
  components: {
    BForm,
    Notes,
    BInputDate,
    FilesUploader,
    BServerAutocomplete,
    BTextarea,
  },
  methods: { getPersonName, CustomDate },
  setup() {
    const { can } = useCan()
    const { orderUpdateExtraDocument, order, disabled } = useOrder()
    const {
      acknowledgmentAccess,
      isAcknowledgmentAgreed,
      acknowledgmentAgree,
      acknowledgmentList,
    } = useAcknowledgment()

    return {
      orderUpdateExtraDocument,
      order,
      navigateToItem,
      urlAllUsers,
      disabled,
      acknowledgmentAccess,
      isAcknowledgmentAgreed,
      acknowledgmentAgree,
      acknowledgmentList,
      can,
    }
  },
}
</script>

<style lang="scss" scoped>
.info {
  background: #f5f6f8;
  padding: 8px;
  display: flex;
  justify-content: space-between;

  span {
    display: block;
    font-size: 12px;
    color: #b5b7c0;
    margin-bottom: 4px;
  }
}
</style>
